import { IPalabrasAgrovocWs } from "../interfaces/Workspace"
import { get } from "./fetch"


export const getPalabrasClaveWs = async (idioma:string = "es"): Promise<IPalabrasAgrovocWs[]> => {
    var palabrasWs:IPalabrasAgrovocWs[] = await get(`/api/palabras-ws?idioma=${idioma}`)
    return palabrasWs
}